/**
 * Menu filtering and sorting utilities
 */

/**
 * Filter and sort menu items
 * 
 * @param menuData - Array of menu items
 * @param selectedCategory - Selected category filter (null for all)
 * @param searchQuery - Search query string
 * @returns Filtered and sorted menu items
 */
export function filterAndSortMenuItems(
  menuData: any[],
  selectedCategory: string | null,
  searchQuery: string
): any[] {
  if (!menuData) return [];
  
  // Step 1: Filter to available items (enabled + verified)
  let filtered = menuData.filter(item => 
    item.is_enabled && 
    item.is_item_verified
  );
  
  // Step 2: Apply category filter
  if (selectedCategory) {
    filtered = filtered.filter(item =>
      item.category === selectedCategory ||
      item.level1_category === selectedCategory ||
      item.level2_category === selectedCategory
    );
  }
  
  // Step 3: Apply search filter
  if (searchQuery.trim()) {
    const query = searchQuery.toLowerCase().trim();
    filtered = filtered.filter(item =>
      item.name.toLowerCase().includes(query) ||
      item.description.toLowerCase().includes(query) ||
      item.category.toLowerCase().includes(query)
    );
  }
  
  // Step 4: Sort by name
  return [...filtered].sort((a, b) => a.name.localeCompare(b.name));
}
